const handleForms = (function (jQuery) {

  const handleValidation = function () {

    if (window.AppLocale === 'fr') {
      $.extend($.validator.messages, {
        required: "Ce champ est obligatoire.",
        remote: "Veuillez corriger ce champ.",
        email: "Veuillez fournir une adresse électronique valide.",
        url: "Veuillez fournir une adresse URL valide.",
        date: "Veuillez fournir une date valide.",
        dateISO: "Veuillez fournir une date valide (ISO).",
        number: "Veuillez fournir un numéro valide.",
        digits: "Veuillez fournir seulement des chiffres.",
        creditcard: "Veuillez fournir un numéro de carte de crédit valide.",
        equalTo: "Veuillez fournir encore la même valeur.",
        notEqualTo: "Veuillez fournir une valeur différente, les valeurs ne doivent pas être identiques.",
        extension: "Veuillez fournir une valeur avec une extension valide.",
        maxlength: $.validator.format("Veuillez fournir au plus {0} caractères."),
        minlength: $.validator.format("Veuillez fournir au moins {0} caractères."),
        rangelength: $.validator.format("Veuillez fournir une valeur qui contient entre {0} et {1} caractères."),
        range: $.validator.format("Veuillez fournir une valeur entre {0} et {1}."),
        max: $.validator.format("Veuillez fournir une valeur inférieure ou égale à {0}."),
        min: $.validator.format("Veuillez fournir une valeur supérieure ou égale à {0}."),
        step: $.validator.format("Veuillez fournir une valeur multiple de {0}."),
        maxWords: $.validator.format("Veuillez fournir au plus {0} mots."),
        minWords: $.validator.format("Veuillez fournir au moins {0} mots."),
        rangeWords: $.validator.format("Veuillez fournir entre {0} et {1} mots."),
        letterswithbasicpunc: "Veuillez fournir seulement des lettres et des signes de ponctuation.",
        alphanumeric: "Veuillez fournir seulement des lettres, nombres, espaces et soulignages.",
        lettersonly: "Veuillez fournir seulement des lettres.",
        nowhitespace: "Veuillez ne pas inscrire d'espaces blancs.",
        ziprange: "Veuillez fournir un code postal entre 902xx-xxxx et 905-xx-xxxx.",
        integer: "Veuillez fournir un nombre non décimal qui est positif ou négatif.",
        vinUS: "Veuillez fournir un numéro d'identification du véhicule (VIN).",
        dateITA: "Veuillez fournir une date valide.",
        time: "Veuillez fournir une heure valide entre 00:00 et 23:59.",
        phoneUS: "Veuillez fournir un numéro de téléphone valide.",
        phoneUK: "Veuillez fournir un numéro de téléphone valide.",
        mobileUK: "Veuillez fournir un numéro de téléphone mobile valide.",
        strippedminlength: $.validator.format("Veuillez fournir au moins {0} caractères."),
        email2: "Veuillez fournir une adresse électronique valide.",
        url2: "Veuillez fournir une adresse URL valide.",
        creditcardtypes: "Veuillez fournir un numéro de carte de crédit valide.",
        ipv4: "Veuillez fournir une adresse IP v4 valide.",
        ipv6: "Veuillez fournir une adresse IP v6 valide.",
        require_from_group: $.validator.format("Veuillez fournir au moins {0} de ces champs."),
        nifES: "Veuillez fournir un numéro NIF valide.",
        nieES: "Veuillez fournir un numéro NIE valide.",
        cifES: "Veuillez fournir un numéro CIF valide.",
        postalCodeCA: "Veuillez fournir un code postal valide.",
        pattern: "Format non valide.",
      });
    }

    function isPanelActive(e) {
      return e.closest('.step-tab-panel.active').is(":visible");
    }

    jQuery.validator.setDefaults({
      lang: AppLocale,
      submitHandler: function (form) {
        form.submit();
      },
      errorElement: 'span',
      errorPlacement: function (error, element) {
        error.addClass('invalid-feedback');
        element.closest('.form-group').append(error);
      },
      highlight: function (element, errorClass, validClass) {
        jQuery(element).addClass('is-invalid');
      },
      unhighlight: function (element, errorClass, validClass) {
        jQuery(element).removeClass('is-invalid').addClass('is-valid');
      },
    });

    jQuery.validator.addMethod('pwcheck', function (value) {
      if (value.length === 0) {
        return true;
      } // don't validate empty password fields
      return /^(.*)$/.test(value) // consists of only these
        && /[a-z]/.test(value) // has a lowercase letter
        && /\d/.test(value) // has a digit
        && value.length >= 10
    });

    jQuery.validator.addMethod('atLeastOneCheckbox', function (value, elem, param) {
      return jQuery(".atLeastOneCheckbox:checkbox:checked").length > 0;
    }, 'Please select at least one');

    /**
     * Check if at least one checkbox is checked. Display an error message
     * if no checkbox is checked.
     */
    jQuery.validator.addMethod('requiredCheckbox', function (value, element) {
      if (isPanelActive(jQuery(element))) {
        let checkboxName = element.getAttribute('name');
        let checkboxs = document.querySelectorAll(`input[name="${checkboxName}"]`);
        let errorMessage = element.dataset.errorMessage ?? 'Veuillez selectionner au moins une valeur.';
        let errorSpan = document.querySelector('#' + element.dataset.errorSpan);
        let isValid = jQuery.validator.methods.required.call(this, jQuery.trim(element.value), element);

        if (!isValid && errorSpan) {
          errorSpan.style.display = 'block';
          errorSpan.textContent = errorMessage;
        } else if (errorSpan) {
          errorSpan.style.display = 'none';
          errorSpan.textContent = '';
        }

        for (let checkbox of checkboxs) {
          let checkboxId = checkbox.id;
          let card = document.querySelector(`div[data-checkbox="${checkboxId}"]`);

          if (!isValid && card) {
            card.classList.add('border-danger');
          } else if (card) {
            card.classList.remove('border-danger')
          }
        }

        return isValid;
      } else {
        return true;
      }
    });

    jQuery.validator.addMethod('requiredIfPanelActive', function (value, element) {
        if (isPanelActive(jQuery(element))) {
          return jQuery.validator.methods.required.call(this, jQuery.trim(element.value), element);
        } else {
          return true;
        }
      }
    );

    jQuery.validator.addMethod('requiredDataTable', function (value, element) {
      if (isPanelActive(jQuery(element))) {
        return Boolean(getDataFromTable('#' + element.dataset.table).length)
      } else {
        return true;
      }
    });

    jQuery.validator.addMethod('alphaNumDashUnderscoreSlash', function (value, element) {
      return this.optional(element) || /^[a-z0-9\-_]+$/i.test(value);
    }, 'letters, numbers, underscores, and dashes only');

    jQuery.validator.addMethod('checkImageDimensions', function (value, element) {
      return this.optional(element) || !jQuery(element).hasClass('invalid-dimension');
    }, 'Les dimensions de l\'image sont incorrectes');

    jQuery.validator.addMethod('maxFileSize', function (value, element) {
      var maxSize = 20; // Mb
      //if(typeof element.files[0] !== 'undefined') {
      //  console.debug('file size = ' +element.files[0].size/1048576 +' Mb');
      //}
      return this.optional(element) || element.files[0].size <= (maxSize * 1048576)
    }, 'La taille du fichier doit être inférieure à 20Mb');

    var formvalidator = jQuery('.form-validator');
    if (formvalidator.length === 0) {
      return;
    }
    window.validator = formvalidator.validate({
      ignore: '.bootstrap-duallistbox-container .filter, .bootstrap-duallistbox-container select'
    });
  };

  const _getSelect2Lang = function () {
    return {
      errorLoading: function () {
        return 'Les résultats ne peuvent pas être chargés.';
      },
      inputTooLong: function (args) {
        var overChars = args.input.length - args.maximum;

        return 'Supprimez ' + overChars + ' caractère' +
          ((overChars > 1) ? 's' : '');
      },
      inputTooShort: function (args) {
        var remainingChars = args.minimum - args.input.length;

        return 'Saisissez au moins ' + remainingChars + ' caractère' +
          ((remainingChars > 1) ? 's' : '');
      },
      loadingMore: function () {
        return 'Chargement de résultats supplémentaires…';
      },
      maximumSelected: function (args) {
        return 'Vous pouvez seulement sélectionner ' + args.maximum +
          ' élément' + ((args.maximum > 1) ? 's' : '');
      },
      noResults: function () {
        return 'Aucun résultat trouvé';
      },
      searching: function () {
        return 'Recherche en cours…';
      },
      removeAllItems: function () {
        return 'Supprimer tous les éléments';
      },
      removeItem: function () {
        return 'Supprimer l\'élément';
      }
    };
  };

  const handleSelect2 = function () {
    var select = jQuery('select.select2');
    if (select.length === 0) {
      return;
    }
    select.each(function () {
      var self = jQuery(this);
      if (self.hasClass("select2-hidden-accessible")) {
        return;
      }
      self.select2({
        theme: 'bootstrap4',
        width: '100%',
        dropdownParent: self.parent(),
        placeholder: function () {
          self.data('placeholder');
        }
      });
    });
  };

  const handleContextSelect2 = function (selectorName) {
    var element = jQuery(selectorName);
    if (element.length === 0) {
      return;
    }
    var Select2lang = _getSelect2Lang();
    if (AppLocale !== 'fr') {
      Select2lang = 'en';
    }

    element.select2({
      language: Select2lang,
      theme: 'classic',
      minimumInputLength: 3,
      multiple: true,
      width: '100%',
      escapeMarkup: function (text) {
        return text;
      },
      ajax: {
        dataType: 'json',
        minimumInputLength: 4,
        delay: 250,
        data: function (params) {
          return {
            q: params.term,
            page: params.page || 1
          };
        },
        cache: true
      },
      templateResult: function (res) {
        if (res.loading) {
          return res.text;
        }
        var text = res.id + ' - ' + res.website + ' - ' + res.url;
        return jQuery(
          '<div class="select2-result-repository clearfix">' +
          '<div class="select2-result">' + text + '</div>' +
          '</div>'
        );
      },
      templateSelection: function (res) {
        var text = res.id + ' - ' + res.website + ' - ' + res.url;
        if (res.website === undefined) {
          text = res.text;
        }
        return '<span title="' + res.id + '">' + text + '</span>';
      },
    });
  };

  const handleSelect2Ajax = function (selectorId, type) {
    var element = jQuery('#' + selectorId);
    if (element.length === 0) {
      return;
    }
    var Select2lang = _getSelect2Lang();
    if (AppLocale !== 'fr') {
      Select2lang = 'en';
    }

    element.select2({
      language: Select2lang,
      theme: 'classic',
      minimumInputLength: 3,
      multiple: true,
      width: '100%',
      escapeMarkup: function (text) {
        return text;
      },
      ajax: {
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            _type: 'query_append',
            term: params.term,
            q: params.term,
            page: params.page || 1
          };
        },
        cache: true
      },
      processResults: function (data) {
        return {
          'results': data.total_count,
          'pagination': {
            'more': data.more
          }
        };
      },
      templateResult: function (res) {
        if (res.loading) {
          return res.text;
        }

        var text = res[type + '_id'] + ' - ' + res[type + '_name'];
        if (type === 'brand') {
          text = res[type + '_name'];
        }

        return jQuery(
          '<div class="select2-result-repository clearfix">' +
          '<div class="select2-result">' + text + '</div>' +
          '</div>'
        );
      },
      templateSelection: function (res) {
        var text = '';
        if (res[type + '_name'] === undefined) {
          text = res.text;
        } else {
          text = res[type + '_id'] + ' - ' + res[type + '_name'];
          if (type === 'brand') {
            text = res[type + '_name'];
          }
        }

        return '<span title="' + res.id + '">' + text + '</span>';
      },
    });
  };

  const handleAccountRoles = function () {
    var accountRoles = jQuery('#user-roles');
    if (accountRoles.length === 0) {
      return;
    }

    accountRoles.change(function () {
      var $self = jQuery(this);
      accountRoles.find('option:selected').each(function () {
        if (
          $self.val().filter(function (s) {
            return s.includes('Option');
          }).length > 1
        ) {
          toastr.error('Vous ne pouvez pas combiner ces options');
          $self.find('option[value="' + jQuery(this).val() + '"]').prop('selected', false);
          return false;
        }
      });
      return false;
    });
  };

  const handleMandateFileUpload = function () {
    var mandateInput = jQuery('#mandate-input');
    if (mandateInput.length === 0) {
      return;
    }

    if (window.AppLocale === 'fr') {
      $.fn.fileinputLocales['fr'] = {
        fileSingle: 'fichier',
        filePlural: 'fichiers',
        browseLabel: 'Parcourir &hellip;',
        removeLabel: 'Retirer',
        removeTitle: 'Retirer les fichiers sélectionnés',
        cancelLabel: 'Annuler',
        cancelTitle: 'Annuler le transfert en cours',
        pauseLabel: 'Suspendre',
        pauseTitle: 'Suspendre le transfert en cours',
        uploadLabel: 'Transférer',
        uploadTitle: 'Transférer les fichiers sélectionnés',
        msgNo: 'Non',
        msgNoFilesSelected: 'Aucun fichier sélectionné',
        msgPaused: 'Suspendu',
        msgCancelled: 'Annulé',
        msgPlaceholder: 'Sélectionner un {files} ...',
        msgZoomModalHeading: 'Aperçu détaillé',
        msgFileRequired: 'Vous devez sélectionner un fichier à envoyer.',
        msgSizeTooSmall: 'Le fichier "{name}" (<b>{size} KB</b>) est inférieur à la taille minimale de <b>{minSize} KB</b>.',
        msgSizeTooLarge: 'Le fichier "{name}" (<b>{size} Ko</b>) dépasse la taille maximale autorisée qui est de <b>{maxSize} Ko</b>.',
        msgFilesTooLess: 'Vous devez sélectionner au moins <b>{n}</b> {files} à transmettre.',
        msgFilesTooMany: 'Le nombre de fichiers sélectionnés <b>({n})</b> dépasse la quantité maximale autorisée qui est de <b>{m}</b>.',
        msgTotalFilesTooMany: 'Il n\'est pas permis d\'envoyer plus de <b>{m}</b> fichiers (actuellement <b>{n}</b> fichiers).',
        msgFileNotFound: 'Le fichier "{name}" est introuvable !',
        msgFileSecured: "Des restrictions de sécurité vous empêchent d'accéder au fichier \"{name}\".",
        msgFileNotReadable: 'Le fichier "{name}" est illisible.',
        msgFilePreviewAborted: 'Prévisualisation du fichier "{name}" annulée.',
        msgFilePreviewError: 'Une erreur est survenue lors de la lecture du fichier "{name}".',
        msgInvalidFileName: 'Caractères invalides ou non supportés dans le nom de fichier "{name}".',
        msgInvalidFileType: 'Type de document invalide pour "{name}". Seulement les documents de type "{types}" sont autorisés.',
        msgInvalidFileExtension: 'Extension invalide pour le fichier "{name}". Seules les extensions "{extensions}" sont autorisées.',
        msgFileTypes: {
          'image': 'image',
          'html': 'HTML',
          'text': 'text',
          'video': 'video',
          'audio': 'audio',
          'flash': 'flash',
          'pdf': 'PDF',
          'object': 'object'
        },
        msgUploadAborted: 'Le transfert du fichier a été interrompu',
        msgUploadThreshold: 'En cours &hellip;',
        msgUploadBegin: 'Initialisation &hellip;',
        msgUploadEnd: 'Terminé',
        msgUploadResume: 'Reprise du transfert &hellip;',
        msgUploadEmpty: 'Aucune donnée valide n\'est disponible pour l\'envoi.',
        msgUploadError: 'Erreur lors du transfert',
        msgDeleteError: 'Erreur de suppression',
        msgProgressError: 'Erreur',
        msgValidationError: 'Erreur de validation',
        msgLoading: 'Transmission du fichier {index} sur {files} &hellip;',
        msgProgress: 'Transmission du fichier {index} sur {files} - {name} - {percent}%.',
        msgSelected: '{n} {files} sélectionné(s)',
        msgFoldersNotAllowed: 'Glissez et déposez uniquement des fichiers ! {n} répertoire(s) exclu(s).',
        msgImageWidthSmall: 'La largeur de l\'image "{name}" doit être d\'au moins {size} px.',
        msgImageHeightSmall: 'La hauteur de l\'image "{name}" doit être d\'au moins {size} px.',
        msgImageWidthLarge: 'La largeur de l\'image "{name}" ne peut pas dépasser {size} px.',
        msgImageHeightLarge: 'La hauteur de l\'image "{name}" ne peut pas dépasser {size} px.',
        msgImageResizeError: "Impossible d'obtenir les dimensions de l'image à redimensionner.",
        msgImageResizeException: "Erreur lors du redimensionnement de l'image.<pre>{errors}</pre>",
        msgAjaxError: "Une erreur s'est produite pendant l'opération de {operation}. Veuillez réessayer plus tard.",
        msgAjaxProgressError: 'L\'opération "{operation}" a échouée',
        msgDuplicateFile: 'Le fichier "{name}" de taille "{size} KB" à déjà été envoyé. Les doublons sont ignorés.',
        msgResumableUploadRetriesExceeded: 'Le transfert a été annulé après <b>{max}</b> essais pour le fichier <b>{file}</b>! Details de l\'erreur: <pre>{error}</pre>',
        msgPendingTime: '{time} restant',
        msgCalculatingTime: 'calcul du temps restant',
        ajaxOperations: {
          deleteThumb: 'suppression du fichier',
          uploadThumb: 'transfert du fichier',
          uploadBatch: 'transfert des fichiers',
          uploadExtra: 'soumission des données du formulaire'
        },
        dropZoneTitle: 'Glissez et déposez les fichiers ici &hellip;',
        dropZoneClickTitle: '<br>(ou cliquez pour sélectionner manuellement)',
        fileActionSettings: {
          removeTitle: 'Supprimer le fichier',
          uploadTitle: 'Transférer le fichier',
          uploadRetryTitle: 'Relancer le transfert',
          downloadTitle: 'Télécharger',
          zoomTitle: 'Voir les détails',
          dragTitle: 'Déplacer / Réarranger',
          indicatorNewTitle: 'Pas encore transféré',
          indicatorSuccessTitle: 'Posté',
          indicatorErrorTitle: 'Ajouter erreur',
          indicatorPausedTitle: 'Transfert suspendu',
          indicatorLoadingTitle: 'En cours &hellip;'
        },
        previewZoomButtonTitles: {
          prev: 'Voir le fichier précédent',
          next: 'Voir le fichier suivant',
          toggleheader: 'Masquer le titre',
          fullscreen: 'Mode plein écran',
          borderless: 'Mode cinéma',
          close: "Fermer l'aperçu"
        }
      };
    }

    jQuery('input[data-mask]').inputmask();

    mandateInput.fileinput({
      theme: 'fas',
      language: AppLocale,
      required: true,
      browseOnZoneClick: true,
      dropZoneEnabled: false,
      showPreview: true,
      showUpload: false,
      showRemove: false,
      showDownload: false,
      showZoom: false,
      showDrag: false,
      elErrorContainer: '#mandate-file-errors',
      allowedFileExtensions: ["jpg", "png", "pdf", "odt", "doc", "docx"],
    });

    jQuery('#new-mandate-form').validate({
      submitHandler: function (form) {
        if (jQuery('#mandate-file-errors').is(":visible")) {
          return;
        }

        var $form = jQuery(form);
        var formData = new FormData(form);
        var formAction = jQuery(form).attr('action');

        $form.find('button[type=submit]').prop("disabled", true);
        $form.find('div.overlay').css('display', 'block');

        $.ajax({
          enctype: 'multipart/form-data',
          url: formAction,
          type: 'POST',
          data: formData,
          cache: false,
          contentType: false,
          processData: false
        }).done(function () {
          document.location.reload();
        });

        return false;
      }
    });

  };

  const handleMandateSwitches = function () {
    var switches = jQuery('.mandates-switches').find('.custom-switch');
    if (switches.length === 0) {
      return;
    }

    switches.on('change.bootstrapSwitch', function (e) {
      var isChecked = e.target.checked ? 'on' : 'off';
      var url = jQuery(this).find('input').attr('data-href');
      var _token = jQuery('#mandates-card').attr('data-token');
      jQuery.ajax({
        method: 'PUT',
        url: url,
        data: {
          '_token': _token,
          'mandate_validated': isChecked
        }
      }).done(function (response) {
        toastr.info(response.success);
      });
    });
  };

  const handleMandateDelete = function () {
    var deleteUrl,
      mandateId,
      deleteMandateModal = jQuery('#delete-mandate-modal');
    if (deleteMandateModal.length === 0) {
      return;
    }

    deleteMandateModal.on('show.bs.modal', function (e) {
      var $this = jQuery(this);
      var row = jQuery(e.relatedTarget);
      var message = row.attr('data-message');
      var title = row.attr('data-title');
      mandateId = row.attr('data-id');
      deleteUrl = row.attr('data-href');
      $this.find('.modal-body p').text(message);
      $this.find('.modal-title').text(title);
    }).find('#confirm').on('click', function () {
      jQuery.ajax({
        type: 'DELETE',
        url: deleteUrl,
        dataType: 'json',
        data: {
          _token: jQuery('#user-mandate-list').attr('data-token'),
          id: mandateId
        },
        encode: true,
      }).done(function (data) {
        deleteMandateModal.modal('toggle');
        if (typeof data.success !== 'undefined') {
          toastr.success(data.success);
          jQuery('#mandate-' + mandateId).remove();
          return;
        }
        toastr.error(data.error);
      });
    });
  }

  function handleDateRangePicker() {
    let dates = document.querySelectorAll('.dateRangePicker');

    for (let date of dates) {
      let startDate = date.dataset.startdate;
      let endDate = date.dataset.enddate;
      let minDate = date.dataset.mindate;
      let maxDate = date.dataset.maxdate;

      jQuery(date).daterangepicker({
        minDate: minDate,
        maxDate: maxDate,
        startDate: startDate,
        endDate: endDate,
        dateFormat: moment.locale(AppLocale),
        autoApply: true,
      });
    }
  }

  const handleInputMaxlength = function () {
    var inputmaxlength = jQuery('[maxlength]');

    if (inputmaxlength.length === 0) {
      return;
    }
    inputmaxlength.maxlength();
  };

  const handleCampaignFormSteps = function () {
    var $form = jQuery('#new_campaign_form');
    if ($form.length === 0) {
      return;
    }

    handleCampaignNonCaptiveBrand();
    handleCampaignFormStep2();
    handleCampaingFormStep3();

    $form.trigger('reset');
    jQuery('#campaing_brand').val('').trigger('change');

    var isInit = false;
    $form.steps({
      onInit: function () {
        var stepsValidator = $form.validate();
        stepsValidator.settings.ignore = []; // needs to be set here /!\
      },
      onChange: function (currentIndex, newIndex, stepDirection) {
        if (!isInit) {
          isInit = true;
          return;
        }

        var percent = (parseInt(currentIndex) / 2) * 100;
        jQuery('.progress-bar').css({width: percent + '%'});

        if (stepDirection === 'backward') {
          return true;
        }

        if ($form.valid()) {
          return true;
        } else if ([1, 2].includes(currentIndex) && stepDirection === 'forward') {
          toastr.error($form.data("validator").errorList[0].message);
        }
      },
      onFinish: function () {
        handleCampaignBudgetRaise($form);
      }
    });
  };

  const handleCampaignFormStep2 = function () {
    var formatCheckboxes = jQuery('#new_campaign_form_step2').find('input[type=checkbox]');
    if (formatCheckboxes.length === 0) {
      return;
    }

    handleHasNoCreative();

    handleCampaignTotalBudgetField();

    formatCheckboxes.click(function () {
        let $self = jQuery(this);
        let totalBudget = jQuery('#campaign_total_budget').val();
        let nbChecked = jQuery('#new_campaign_form_step2').find('input[type=checkbox]:checked').length;

        if (totalBudget < nbChecked * 1000) {
          $self.prop("checked", false);

          toastr.info(`
            Votre budget total est de ${totalBudget} €
            vous ne pouvez pas ajouter de format supplémentaire<br>
            Pour ajouter un format, veuillez<br>
            <a class="text-bold text-secondary" onclick="getBackToBudget()">
            augmenter votre budget total <i class="fa fa-arrow-alt-circle-left"></i></a>
          `)
          return;
        }

        let campaignType = $self.attr('id');
        let isChecked = $self.is(':checked');

        if (isChecked) {
          jQuery('#row-' + campaignType).removeClass('d-none');
        } else {
          jQuery('#row-' + campaignType).addClass('d-none');
        }
      }
    )
  };

  const handleCampaingFormStep3 = function () {
    var tableReports = jQuery('#table-reports');
    var tableElements = jQuery('#table-reports th.hoverable, #table-reports td.hoverable');

    tableElements.hover(function () {
      var index = jQuery(this).index();
      tableElements.filter(':nth-child(' + (index + 1) + ')').addClass('current-col');
      jQuery('#table-reports th').filter(':nth-child(' + (index + 1) + ')').addClass('current-col');
    }, function () {
      tableElements.removeClass('current-col');
    });

    tableReports.on('click', '.hoverable.current-col', function () {
      var index = jQuery(this).index();
      var tableHead = jQuery('#table-reports thead tr th').eq(index)
      var reportInput = tableHead.find('input');

      tableElements.removeClass('clicked-col');
      tableElements.filter(':nth-child(' + (index + 1) + ')').addClass('clicked-col');
      jQuery('#table-reports th').filter(':nth-child(' + (index + 1) + ')').addClass('clicked-col');

      jQuery('#campaign_report_' + reportInput.val()).prop("checked", true);
    });

    tableReports.find('input[name="campaign_report"]:checked')
      .parent('.hoverable')
      .addClass('current-col')
      .click();

    handleCampaignFormStep3Categories();
    validateCampaignProductsIds('fnac');
    validateCampaignProductsIds('darty');
  };

  const handleCampaignFormStep3Categories = function () {
    window.jQuery.fn.setSelect2Placeholder = function (placeholder) {
      jQuery(this).data('select2').selection.placeholder.text = placeholder;
      jQuery(this).trigger('change');
    };

    const jqTransfertCategories = function (name, categories) {
      var brandSelector = jQuery('#brands_' + name);
      jQuery('#categories_' + name).transfer({
        'groupDataArray': categories,
        'groupItemName': 'groupName',
        'groupArrayName': 'groupData',
        'itemName': 'name',
        'valueName': 'value',
        'tabNameText': 'Catégories',
        'rightTabNameText': 'Catégories sélectionnées',
        'searchPlaceholderText': 'Rechercher',
        'callable': function (items) {
          if (items.length > 0) {
            brandSelector.setSelect2Placeholder('Veuillez sélectionner');
          } else {
            brandSelector.setSelect2Placeholder('Veuillez d\'abord sélectionner une catégorie');
            brandSelector.val(null).trigger('change');
          }
          jQuery('input[name="categories_' + name + '"]').val(JSON.stringify(items));
          brandSelector.find('optgroup:not(:disabled)').attr('disabled', 'disabled');
          var categoriesForBrands = items.map(item => item.value)
            .filter(function (value, index, self) {
              return self.indexOf(value) === index;
            });
          categoriesForBrands.forEach(function (label) {
            brandSelector.find('optgroup[label="' + label + '"]').removeAttr('disabled');
          });
          brandSelector.find('optgroup:disabled').find('option:selected').removeAttr('selected');
          brandSelector.trigger('change');
        }
      }).applyCallable(JSON.parse(jQuery('input[name="categories_' + name + '"]').val()));
    };

    jQuery.getScript("/js/jquery-transfert.js", function () {
      jqTransfertCategories('fnac', window.categoriesFnac);
      jqTransfertCategories('darty', window.categoriesDarty);

      setTimeout(function () {
        jQuery('.transfer-double-list-search-input, ' +
          '.transfer-double-selected-list-search-input')
          .keypress(function (event) {
            if (event.keyCode === 10 || event.keyCode === 13) {
              event.preventDefault();
            }
          });
      }, 3000);

    });
  };

  const handleHasNoCreative = function () {
    var missingCreativeModal = jQuery('#missing-creative-modal');
    if (missingCreativeModal.length) {
      missingCreativeModal.modal('show');
      jQuery('#campaign_onsite_display, #campaign_offsite_display, #campaign_offsite_video, #campaign_offsite_native')
        .next('.card')
        .on('click', function () {
          missingCreativeModal.modal('show');
        });
    }
  };

  const handleCampaignTotalBudgetField = function () {
    var totalBudgetField = jQuery('#campaign_total_budget');
    totalBudgetField.on('focusin', function () {
      jQuery(this).data('val', jQuery(this).val());
    });
    totalBudgetField.on('change', function () {
      var oldValue = jQuery(this).data('val');
      var newValue = this.value;
      if (oldValue > newValue) {
        _resetCampaignSelectedFormats();
      }
    });

    window.getBackToBudget = function () {
      jQuery('button[data-step-action=prev]:visible').click();
      totalBudgetField.removeClass('is-valid').focus();
      return false;
    }
  };

  const validateCampaignProductsIds = function (store) {
    var $element = jQuery('#ids_products_' + store);
    var range = [
      parseInt($element.attr('data-productIdLengthMin')),
      parseInt($element.attr('data-productIdLengthmax'))
    ];
    $element.on('beforeItemAdd', function (event) {
      if (isNaN(parseInt(event.item)) || !range.includes(event.item.length)) {
        toastr.error(
          'l\'ID Produit ' +
          store.replace(/^./, store[0].toUpperCase()) +
          ' n\'est pas valide, ' +
          range.filter((v, i, a) => a.indexOf(v) === i).toString() +
          ' chiffres sont requis'
        );
        event.cancel = true;
      }
    });
  };

  const handleCampaignBudgetRaise = function ($form) {
    var selectedReport = jQuery('input[name=campaign_report]').filter(':checked');
    var reportPrice = parseInt(selectedReport.attr('data-report-price'));
    if (reportPrice !== 0) {
      var reportType = selectedReport.val();
      var modal = jQuery('#budgetRaiseModal')
      modal.find('.report-name').html(reportType);
      modal.find('.report-price').html(reportPrice + ' €');
      modal.modal('show');
    } else {
      $form.submit();
    }
  }

  const handleCampaignNonCaptiveBrand = function () {
    const $hiddenParts = jQuery('.hidden-ifBrandNonCaptive');
    const $message = jQuery('#visible-ifBrandNonCaptive');
    const $brandSelect = jQuery('#campaign_brand');
    $brandSelect.change(function () {
      $hiddenParts.show();
      $message.hide();
      let $selected = jQuery(this).find('option:selected');
      let isNonCaptiveBrand = ($selected.attr('data-is-non-captive') === 'true');
      if(isNonCaptiveBrand) {
        $hiddenParts.hide();
        $message.show();
        _resetCampaignSelectedFormats();
      }
    });
  };

  const _resetCampaignSelectedFormats = function() {
    jQuery('#new_campaign_form_step2').find('input[type=checkbox]').prop('checked', false);
    jQuery('tr[id^=row-campaign_]:not(.d-none)').addClass('d-none');
  }

  const handleSwitches = function () {
    var switches = jQuery('.boostrap-switch');
    if (switches.length === 0) {
      return;
    }
    switches.bootstrapSwitch();
  };

  const handleDualBox = function () {
    jQuery("select[id^='dualBox_']").each(function () {
      let $self = jQuery(this);

      if ($self.hasClass('dualbox-loaded')) {
        return;
      }

      let duallist = jQuery('#' + this.id).bootstrapDualListbox({
        selectorMinimalHeight: 300,
        moveOnSelect: false,
        iconsPrefix: 'fa',
        iconMove: 'fa-arrow-right',
        iconRemove: 'fa-arrow-left',
        filterPlaceHolder: 'Rechercher',
        infoText: '',
        infoTextFiltered: '',
        infoTextEmpty: '',
        filterTextClear: 'Afficher tout'
      });

      let customSettings = duallist.bootstrapDualListbox('getContainer');
      customSettings.find('.moveall i').removeClass().addClass('fa fa-angle-double-right').next().remove();
      customSettings.find('.move i').removeClass().addClass('fa fa-angle-right').next().remove();
      customSettings.find('.removeall i').removeClass().addClass('fa fa-angle-double-left').next().remove();
      customSettings.find('.remove i').removeClass().addClass('fa fa-angle-left').next().remove();

      $self.addClass('dualbox-loaded');
    });
  }


  function selectionbrandsProduct(brandSelector, configuration) {
    var brandsOverlay = jQuery('#brands-overlay');
    var specsUrl = brandSelector.data(configuration['urlBrandAjax']);
    brandSelector.on('select2:select', function (e) {
      brandsOverlay.removeClass('d-none');
      var element = e.params.data.element;
      var $element = jQuery(element);
      var data = e.params.data;
      var brandsSpecsTable = jQuery('#' + configuration['specTable']);
      $element.detach();
      jQuery(this).append($element).trigger('change');
      jQuery.get(specsUrl + '/' + data.id, function (html) {
        var tableRow = '<tr id="row-' + data.id + '">' +
          '<td>' + data.text.trim() + '</td>' +
          '<td>' +
          '<i class="fa fa-cog" style="cursor:pointer" data-toggle="modal" data-target="#' + configuration['brandSpec'] + data.id +
          '"></i>' + html + '</td>' +
          '</tr>';
        brandsOverlay.addClass('d-none')
        brandsSpecsTable.find('tbody').first().append(tableRow);
        handleSelect2();
        handleContextSelect2('#' + configuration['brandContext'] + data.id);
        handleDualBox();
      });
    });

    brandSelector.on('select2:unselect', function (e) {
      var data = e.params.data;
      jQuery('#row-' + data.id).remove();
    });
  }

  const handleUserBrandSpecsDarty = function () {
    var brandDartySelector = jQuery('#brandsDarty');
    if (brandDartySelector.length === 0) {
      return;
    }

    var configuration = {
      'urlBrandAjax' : 'brandspecs-darty-ajax-url',
      'specTable' : 'brands-specs-list-darty',
      'brandContext' : 'brand-contexts-',
      'brandSpec' : 'brand-specs-',
    };

    handleDualBox();
    selectionbrandsProduct(brandDartySelector, configuration);
  };

  const handleUserBrandSpecsFnac = function () {
    var brandFnacSelector = jQuery('#brandsFnac');
    if (brandFnacSelector.length === 0) {
      return;
    }

    var configuration = {
      'urlBrandAjax' : 'brandspecs-fnac-ajax-url',
      'specTable' : 'brands-specs-list-fnac',
      'brandContext' : 'brand-contexts-',
      'brandSpec' : 'brand-specs-',
    };

    handleDualBox();
    selectionbrandsProduct(brandFnacSelector, configuration);
  };

  const handleUserBrandSpecs = function () {
    var brandSelector = jQuery('#brands');
    if (brandSelector.length === 0) {
      return;
    }

    var configuration = {
      'urlBrandAjax' : 'brandspecs-ajax-url',
      'specTable' : 'brands-specs-list',
      'brandContext' : 'brand-contexts-',
      'brandSpec' : 'brand-specs-',
    };

    handleDualBox();
    selectionbrandsProduct(brandSelector, configuration);
  };

  /**
   * Convert LI format to Creative format.
   */
  function insertCreativesFromFormat() {
    let creativesInput = document.querySelector('#creatives_select');
    let inventory = document.querySelector('#line_item_form_steps').dataset.inventory;
    let format = document.querySelector('select[name="format"]').value;

    /** Reset related table if creatives input has select2-to-table class. */
    if (creativesInput.classList.contains('select2-to-table')) {
      let table = creativesInput.dataset.table;

      jQuery(`#${table}`).closest('tbody').innerHTML = '';
    }

    jQuery(creativesInput).select2({
      theme: 'bootstrap4',
      width: '100%',
      ajax: {
        url: '/activation/creatives/fromFormat',
        dataType: 'json',
        data: {
          inventory: convertToCreativeInventory(inventory),
          format: convertToCreativeFormat(format)
        }
      }
    });
  }

  /**
   * Line Item Creation Form.
   */
  const handleLIFormSteps = function () {
    let $form = jQuery('#line_item_form_steps');
    let inventory = $form.data('inventory');
    let format = $form.data('format');

    if ($form.length === 0) {
      return;
    }

    jQuery('#line_item_form_steps input[name=inventory]:checkbox').on('click', function () {
      let $box = jQuery(this);
      if ($box.is(":checked")) {
        var group = "input:checkbox[name='" + $box.attr("name") + "']";
        jQuery(group).prop("checked", false);
        $box.prop("checked", true);
      } else {
        $box.prop("checked", false);
      }
    });

    updateProgressBar(0);
    initSelect2ToTable();
    handleCpmAndBudget();

    let isInit = false;

    let steps = $form.steps({
      onInit: function () {
        let stepsValidator = $form.validate();
        stepsValidator.settings.ignore = [];
      },

      onChange: function (currentIndex, newIndex, stepDirection) {
        if (!isInit) {
          isInit = true;
          return;
        }
        if (currentIndex === newIndex && stepDirection === 'none') {
          jQuery('*[data-step="step' + (newIndex + 1) + '"')
            .find('.is-valid').each(function () {
            jQuery(this).removeClass('is-valid');
          });
          return;
        }

        if (inventory === 'onsite' && format === 'display' && newIndex === 2) {
        }

        if (stepDirection === 'backward') {
          updateProgressBar(parseInt(newIndex));
          return true;
        }

        if ($form.valid()) {
          updateProgressBar(parseInt(newIndex));
          return true;
        }
      },

      onFinish: function () {

        $form.submit();
      }
    });

    let stepsApi = steps.data('plugin_Steps');
    let maxStepsIndex = stepsApi.getMaxStepIndex();

    function updateProgressBar(index) {
      let progressBar = document.querySelector('.progress-bar');
      if (index !== 0) {
        progressBar.style.width = (index / maxStepsIndex) * 100 + '%';
      } else {
        progressBar.style.width = '0%';
      }
    }
  };

  /**
   * Return an array that contains the table's data.
   *
   * @param tableIdentifier
   * @param datasetKey
   * @returns {*[]}
   */
  function getDataFromTable(tableIdentifier = 'table', datasetKey = 'id') {
    let tableData = [];

    for (let tr of jQuery(`${tableIdentifier} tr`)) {
      tableData.push(tr.dataset[datasetKey]);
    }

    return tableData;
  }

  const initSelect2ToTable = function () {
    window.destroyRow = function (el) {
      el.parentNode.parentNode.remove();
    };

    const createRow = function (id, text, table) {
      if (!id) {
        return
      }

      let alreadyExists = table.querySelector(`tr[data-id="${id}"]`);

      if (alreadyExists) {
        toastr.warning(`${text} est déjà sélectionné.`);
        return;
      }

      let row = document.createElement('tr');

      row.dataset.id = id;

      row.innerHTML = `
          <th class="text-sm" scope="row">${text}</th>
          <td class="text-right">
            <a class="text-danger pointer" onclick="destroyRow(this)">
              <i class="fas fa-times text-sm"></i>
            </a>
          </td>`;

      return row;
    }

    jQuery('.select2-to-table').on('select2:select', (e) => {
      let data = e.params.data;
      let select2 = e.currentTarget;
      let table = document.getElementById(select2.dataset.table);
      let row = createRow(data.id, data.text, table);

      if (row) {
        jQuery(table).children('tbody')[0].appendChild(row);
      }
    });
  }

  /**
   *  Format target cpm value
   */
  const handleFormatValueRateCard = function() {
     let ratecardTargetCpm = document.querySelectorAll(".ratecard-target-cpm").forEach(item => {
       item.addEventListener('input', event => {
         item.value = item.value.replace(',','.')
      })
    })
  };

  /**
   * Update CPM and Budget based on selected format and Ratecard information.
   */
  const handleCpmAndBudget = function () {
    if (typeof window.ratecard === undefined) {
      return;
    }

    let formatSelect = document.querySelector('#format');

    setCPMValue(formatSelect);

    formatSelect.addEventListener('change', e => {
      setCPMValue(e.currentTarget);
    });
  };

  function setCPMValue(formatInput) {
    let formatValue = formatInput.value;
    let cpm;

    if (formatValue) {
      // Special case for 'native' format, which does not exist in ratecard.
      if (formatValue === 'native') {
        formatValue = 'display_native_ads';
      }

      cpm = '?';
      if (window.ratecard[formatValue]?.target_cpm !== undefined && window.ratecard[formatValue].target_cpm !== '') {
        cpm = window.ratecard[formatValue].target_cpm
      }
    } else {
      cpm = '';
    }
    document.querySelector('#cpm').value = cpm;
  }

  const handleTagsInputCopyPaste = function () {
    var $tagsInputs = jQuery('.bootstrap-tagsinput');
    if ($tagsInputs.length === 0) {
      return;
    }
    $tagsInputs.on('paste', 'input', jQuery.proxy(function (event) {
      var $input = jQuery(event.target);
      setTimeout(function () {
        var textLength = $input.val().length,
          wordSpace = Math.ceil(textLength / 5),
          size = textLength + wordSpace + 1;
        $input.attr('size', Math.max(this.inputSize, $input.val().length));
        $input.trigger('keypress');
      }, 100);
    }, self));
  };

  jQuery(function () {
    handleUserBrandSpecs();
    handleUserBrandSpecsDarty();
    handleUserBrandSpecsFnac();
    handleValidation();
    handleSelect2();
    handleAccountRoles();
    handleMandateFileUpload();
    handleMandateSwitches();
    handleMandateDelete();
    handleInputMaxlength();
    handleCampaignFormSteps();
    handleDateRangePicker();
    handleSwitches();
    handleContextSelect2('select[id^="brand-contexts-"]');
    handleLIFormSteps();
    handleTagsInputCopyPaste();
    handleSelect2Ajax('user-brandsInsights', 'brand');
    handleSelect2Ajax('user-suppliers', 'supplier');
    handleFormatValueRateCard();
  });

})(jQuery);
